import DiagramElement from './diagramElement'

export default abstract class ActionElement extends DiagramElement {
}